export default "__VITE_ASSET__C7PBBUiP__"